<template>
  <div>
    <draggable
      class="tasks-list draggable"
      :class="!enabled && 'disabled'"
      :disabled="!enabled"
      tag="div"
      @add="onAdd"
      :component-data="{ attrs: { date: date } }"
      v-model="draggableTasks"
      v-bind="{
        animation: 200,
        delay: 200,
        delayOnTouchOnly: true,
        group: 'tasks'
      }"
      >
        <task v-for="task in draggableTasks" :key="task._id" :id="task._id" :date="task.endDate" :task="task" :draggable="true" :folders="folders" :selected-folder="selectedFolder" class="cursor-grab"></task>
    </draggable>
    <slot></slot>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { hasTime } from '../utils'
import { patchNoteBlock } from '../lib/notes'
import Task from '@/components/Task'

export default {
  name: 'TaskDraggable',
  components: {
    draggable, Task
  },
  props: {
    tasks: Array,
    date: String,
    selectedFolder: Object,
    folders: Array,
    enabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    draggableTasks: {
      get() { return this.tasks },
      set(tasks) {
        // TODO:
        // console.log('set', tasks)
        // this.$store.commit('updateTaskOrder', tasks)
        // this.tasks.map((tasks, index) => {
        //   tasks.order = index + 1
        // })
      }
    }
  },
  methods: {
    onAdd(evt) {
      const taskId = evt.item.getAttribute('id')
      const currentEndDate = evt.item.getAttribute('date')
      const targetDate = evt.to.getAttribute('date')

      let endDateString = targetDate
      if (hasTime(currentEndDate)) {
        endDateString += 'T' + currentEndDate.split('T').pop()
      }

      let dateObject = {}

      dateObject = {
        endDate: endDateString
      }

      const { Task } = this.$FeathersVuex.api
      const taskOnStore = Task.getFromStore(taskId)
      const taskToPatch = new Task({ ...taskOnStore, ...dateObject })
      taskToPatch.patch()

      const { Note } = this.$FeathersVuex.api
      patchNoteBlock(Note, taskOnStore.noteId, taskId,
        block => block.setAttribute('data-end-date', dateObject.endDate))
    }
  }
}
</script>

<style lang="scss">
.tasks-list{
  &.draggable {
    min-height: 12px;
    list-style: none;
    &:empty {
      left: -16px;
      position: relative;
      & + .task-form {
        margin-top: -10px;
      }
    }
  }

  .sortable-chosen {
    background: white;
    opacity: 1;
    visibility: visible;
  }

  .sortable-ghost {
    background-color: #EEEEEE;
    opacity: 0.5;
    box-shadow: none;
    margin-right: 16px;
  }
}
</style>
